
export default function ProductSeries() {
  const products = [
    {
      id: 1,
      name: '餐前控',
      series: '精准饮食管理',
      description: '扫油片·控控片·黑珍珠',
      scenario: '大餐前阻断，轻松享受美食',
      detail: '白芸豆、甲壳素科学配比，餐前一片，告别负担',
      image: 'https://public.readdy.ai/ai/img_res/de4d8abdad802efb9ca46611f11e5ddb.jpg',
      bgColor: 'bg-gradient-to-br from-[#a3c1c3]/10 to-[#bbcbda]/10'
    },
    {
      id: 2,
      name: '元能黑咖',
      series: '科学能量供给',
      description: '生酮咖啡·肉桂姜黄咖啡·双倍黑咖啡',
      scenario: '晨起提神，运动前燃脂加速',
      detail: 'MCT供能+姜黄抗炎，每一口都是科学配比',
      image: 'https://readdy.ai/api/search-image?query=Premium%20coffee%20product%20series%20with%20modern%20minimalist%20packaging%2C%20three%20elegant%20black%20coffee%20containers%20with%20subtle%20purple%20and%20gold%20accents%2C%20professional%20product%20photography%2C%20clean%20composition%20with%20soft%20shadows%2C%20health-focused%20luxury%20branding%2C%20sophisticated%20aesthetic%20with%20scientific%20precision%20feel&width=400&height=400&seq=product-2&orientation=squarish',
      bgColor: 'bg-gradient-to-br from-[#e8dbd3]/10 to-[#daa88f]/10'
    },
    {
      id: 3,
      name: '燃燃茶膏',
      series: '精准饮食管理',
      description: '白芸豆青梅左旋肉碱普洱茶膏',
      scenario: '随餐饮用，促进代谢燃脂',
      detail: '普洱茶褐素+藤黄果+左旋肉碱协同作用',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20tea%20product%20packaging%20with%20premium%20design%2C%20sophisticated%20tea%20paste%20or%20powder%20container%20with%20traditional%20Chinese%20tea%20elements%20combined%20with%20modern%20minimalist%20aesthetic%2C%20soft%20green%20and%20beige%20color%20palette%2C%20professional%20product%20photography%2C%20clean%20white%20background%2C%20luxury%20health%20supplement%20feel&width=400&height=400&seq=product-3&orientation=squarish',
      bgColor: 'bg-gradient-to-br from-[#a6b89e]/10 to-[#bbcbda]/10'
    },
    {
      id: 4,
      name: '轻元奶昔',
      series: '科学能量供给',
      description: '营养奶昔·蛋白棒·谷物棒',
      scenario: '便捷代餐，高蛋白低GI',
      detail: '替代正餐，营养全面，轻松控卡',
      image: 'https://readdy.ai/api/search-image?query=Modern%20protein%20shake%20and%20nutrition%20bar%20packaging%20with%20clean%20minimalist%20design%2C%20elegant%20containers%20and%20bars%20in%20soft%20pastel%20colors%2C%20professional%20product%20photography%2C%20health-focused%20branding%2C%20premium%20feel%20with%20scientific%20precision%2C%20clean%20white%20background&width=400&height=400&seq=product-4&orientation=squarish',
      bgColor: 'bg-gradient-to-br from-[#daa88f]/10 to-[#e8dbd3]/10'
    },
    {
      id: 5,
      name: '元萃粉',
      series: '日常营养支持',
      description: '每日果蔬粉·早补晚眠',
      scenario: '基础营养补充，体质调理',
      detail: '维生素+矿物质+益生菌，日常营养全覆盖',
      image: 'https://readdy.ai/api/search-image?query=Premium%20nutritional%20powder%20packaging%20with%20sophisticated%20design%2C%20elegant%20containers%20for%20daily%20supplements%2C%20soft%20natural%20colors%20with%20mint%20green%20and%20beige%20tones%2C%20professional%20product%20photography%2C%20clean%20minimalist%20aesthetic%2C%20health%20and%20wellness%20focused%20branding&width=400&height=400&seq=product-5&orientation=squarish',
      bgColor: 'bg-gradient-to-br from-[#a3c1c3]/10 to-[#a6b89e]/10'
    },
    {
      id: 6,
      name: '科学家系列',
      series: '专业周期方案',
      description: '21天冲刺套餐',
      scenario: '系统方案+营养师指导+数据跟踪',
      detail: '产品组合配一对一专业服务，科学达成目标',
      image: 'https://readdy.ai/api/search-image?query=Professional%20scientific%20product%20set%20with%20elegant%20packaging%2C%20multiple%20premium%20health%20products%20arranged%20together%2C%20sophisticated%20laboratory-inspired%20design%20with%20purple%20and%20mint%20accents%2C%20professional%20photography%2C%20premium%20luxury%20feel%2C%20clean%20white%20background%2C%20scientific%20precision%20aesthetic&width=400&height=400&seq=product-6&orientation=squarish',
      bgColor: 'bg-gradient-to-br from-[#847eba]/10 to-[#bbcbda]/10'
    }
  ];

  return (
    <section id="products" className="py-16 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-32">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-2xl lg:text-4xl font-light text-gray-800 mb-4 lg:mb-6">
            科学之下的轻松哲学
          </h2>
          <p className="text-sm lg:text-lg text-gray-600 font-light max-w-3xl mx-auto leading-relaxed">
            每一款产品都是科学有效的基础上，追求易于坚持、体验愉悦的轻松哲学实体化体现
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {products.map((product) => (
            <div key={product.id} className="group cursor-pointer" data-product-shop>
              <div className={`${product.bgColor} rounded-3xl p-4 lg:p-6 hover:shadow-xl transition-all duration-500 group-hover:-translate-y-2`}>
                <div className="text-center">
                  {/* 产品系列标签 */}
                  <div className="inline-block px-2 lg:px-3 py-1 bg-[#847eba]/10 text-[#847eba] text-xs font-medium rounded-full mb-3 lg:mb-4">
                    {product.series}
                  </div>
                  
                  <div className="mb-4 lg:mb-6">
                    <img 
                      src={product.image}
                      alt={product.name}
                      className="w-32 lg:w-40 h-32 lg:h-40 mx-auto object-contain"
                    />
                  </div>
                  
                  <h3 className="text-lg lg:text-xl font-medium text-gray-800 mb-2">
                    {product.name}
                  </h3>
                  
                  <p className="text-[#847eba] font-medium mb-2 lg:mb-3 text-xs lg:text-sm">
                    {product.description}
                  </p>
                  
                  <p className="text-gray-600 text-xs lg:text-sm font-light leading-relaxed mb-2">
                    {product.scenario}
                  </p>
                  
                  <p className="text-gray-500 text-xs font-light leading-relaxed mb-3 lg:mb-4">
                    {product.detail}
                  </p>
                  
                  <div className="mt-3 lg:mt-4">
                    <button className="inline-flex items-center text-[#847eba] hover:text-[#6b5d9a] transition-colors duration-300 font-medium whitespace-nowrap text-xs lg:text-sm">
                      了解详情
                      <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform duration-300"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 产品理念补充说明 */}
        <div className="mt-12 lg:mt-16 text-center">
          <div className="bg-gradient-to-r from-[#847eba]/5 to-[#a3c1c3]/5 rounded-2xl p-6 lg:p-8 max-w-4xl mx-auto">
            <p className="text-xs lg:text-base text-gray-600 font-light leading-relaxed">
              <span className="text-[#847eba] font-medium">科学有效是基础，易于坚持、体验愉悦才是关键。</span><br />
              每个产品系列都针对不同场景精心设计，让健康管理成为生活中自然而愉悦的一部分。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
